var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 180,
    viewBox: "0 0 190 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.471 37.0545C72.1289 35.3708 87.0002 47.5036 88.6952 64.1603C90.3901 80.817 78.2677 95.6965 61.6122 97.403C44.9404 99.1111 30.0433 86.9744 28.3465 70.3016C26.6499 53.6285 38.7969 38.7397 55.471 37.0545Z",
    fill: "#ED1D79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1628 114.296C107.128 113.64 118.163 123.635 118.787 136.602C119.411 149.569 109.388 160.578 96.4196 161.17C83.497 161.76 72.5348 151.78 71.9125 138.859C71.2904 125.938 81.2432 114.951 94.1628 114.296Z",
    fill: "#ED1D79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.359 57.2912C145.094 56.1034 153.124 62.2619 154.241 71.0065C155.359 79.7511 149.136 87.731 140.383 88.7785C131.728 89.8142 123.858 83.677 122.753 75.0308C121.648 66.3849 127.722 58.4654 136.359 57.2912Z",
    fill: "#ED1D79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFat);
export default __webpack_public_path__ + "static/media/fat.a2712d3fc2a3033063f9a1e3016ff432.svg";
export { ForwardRef as ReactComponent };